import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import { CTA } from "../../general/Button";
import config from "../../../config/channels";
import useSiteContext from "../../../contexts/site/useSiteContext";
import {useNavigate} from "react-router-dom";
import TinyModal from "../../general/TinyModal";

type LeavingModalProps = {
    show: boolean;
    onHide: () => void;
};

const ChangeAddressModal = ({
                          show,
                          onHide,
                      }: LeavingModalProps) => {

    const navigate = useNavigate();
    const siteContext = useSiteContext();
    const isDineIn = siteContext.channel === config.dineIn.name;


    useEffect(() => {
        document.getElementById('change-address-modal')?.classList.add('anim-enter');

        return () => {
            document.getElementById('change-address-modal')?.classList.remove('anim-enter');
        };
    }, [show]);

    const renderFooter = () => {
        return (
            <>
                <CTA secondary buddies
                     onClick={() => navigate(`/${isDineIn ? config.dineIn.handle : siteContext.channel}`)}
                >
                    <span>Change address</span>
                </CTA>
                <CTA buddies
                     onClick={onHide}>
                    <span>Continue</span>
                </CTA>
            </>
        )
    }

    return (
        <TinyModal
            show={show}
            onHide={onHide}
            modalID={'change-address-modal'}
            header="Change address?"
            footer={renderFooter()}
        >
            <>
                <p>Changing your address will empty your basket. Continue with the current address?</p>
            </>
        </TinyModal>
    );
};


export default ChangeAddressModal;
